export const APP_ID = 'd5ce4eb6'
export const APP_KEY = 'f72c1961fa0630af2494ab843ef2c3df'

/* Credentials provided by https://developer.edamam.com/ */


